export enum ACCOUNTING_HEADING_TYPE {
    INCOME = 'income',
    EXPENSE = 'expense',
    ESTIMATE = 'estimate',
}
export type AccountingHeading = {
    id: string;
    tenant: {
        id: string;
        name: string;
    };
    parent: {
        id: string;
        name: string;
    };
    created_at: string;
    modified_at: string;
    name: string;
    account: string;
    type: ACCOUNTING_HEADING_TYPE;
    partide: string | null;
    billing_entity: {
        id: string;
        name: string;
    };
};
